import { render, staticRenderFns } from "./kv-textfield.vue?vue&type=template&id=c32a99be"
import script from "./kv-textfield.vue?vue&type=script&lang=js"
export * from "./kv-textfield.vue?vue&type=script&lang=js"
import style0 from "./kv-textfield.vue?vue&type=style&index=0&id=c32a99be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports